import * as React from 'react'
import { Modal, Spacing, Align } from 'DVWebNodeUI'
import { acknowledgeEvent } from './utils'

type RenderProp = (args: ModalRenderPropArgs) => React.ReactChild

export type CloseModal = () => void
export type OpenModal = () => void
export type OpenModalClickHandler = (e: React.MouseEvent<HTMLElement>) => void

export interface ToggleRenderPropArgs {
  openModal: OpenModal
  openModalClickHandler: OpenModalClickHandler
  closeModal: CloseModal
}

export interface ModalRenderPropArgs {
  closeModal: CloseModal
}

interface ModalTriggerProps {
  isOpen?: boolean
  toggle?: (args: ToggleRenderPropArgs) => React.ReactChild
  modalContent: React.ReactChild | RenderProp
  modalFooter?: React.ReactChild | RenderProp
  modalHeader?: React.ReactChild | RenderProp
  modalId?: string
  onClose?: () => void
}

interface State {
  isVisible: boolean
}
export class ModalTrigger extends React.Component<ModalTriggerProps, State> {
  state = {
    isVisible: Boolean(this.props.isOpen),
  }

  static getDerivedStateFromProps(props: ModalTriggerProps, state: State) {
    if (props.isOpen !== state.isVisible) {
      return {
        isVisible: props.isOpen,
      }
    }
    return null
  }

  openModal = (): void => {
    this.setState({ isVisible: true })
  }

  openModalClickHandler = (e: React.MouseEvent<HTMLElement>): void => {
    acknowledgeEvent(e)
    this.openModal()
    e.preventDefault()
  }

  closeModal = (): void => {
    this.setState({ isVisible: false })
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render() {
    const closeModal = this.closeModal

    const toggleRenderPropArgs = {
      openModal: this.openModal,
      openModalClickHandler: this.openModalClickHandler,
      closeModal,
    }

    const modalRenderPropArgs = {
      closeModal,
    }

    const { modalContent, modalHeader, modalFooter, toggle, modalId } = this.props

    const footer =
      typeof modalFooter === 'function'
        ? modalFooter(modalRenderPropArgs)
        : modalFooter
    const header =
      typeof modalHeader === 'function'
        ? modalHeader(modalRenderPropArgs)
        : modalHeader
    const content =
      typeof modalContent === 'function'
        ? modalContent(modalRenderPropArgs)
        : modalContent

    return (
      <>
        {this.state.isVisible && (
          <Modal
            className={'av-narrow'}
            isVisible={true}
            onClose={closeModal}
            footer={<div className={Align.right}>{footer}</div>}
            header={<h3 className={Spacing.medium}>{header}</h3>}
            modalId={modalId}
          >
            {content}
          </Modal>
        )}
        {toggle && toggle(toggleRenderPropArgs)}
      </>
    )
  }
}
